import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect, useRef, useState } from "preact/hooks";

import { fetchProductGroups, resolveSwatchImagesFromProducts } from "../../helpers"

export default () => {
    const { query, response: { products } } = useAppState();
    const [ swatchData, setSwatchData ] = useState([]);
    const lastQueryRef = useRef(undefined);

    useEffect(() => {
        if(!products?.hits || products.hits?.length < 1) return;

        const isNewQuery = query.query && query.query !== lastQueryRef?.current;
        if(isNewQuery) {
            lastQueryRef.current = query.query;
        }

        // determine new product groups to query
        const groupsToFetch = [];
        const swatchDataToKeep = [];
        products.hits.forEach(product => {
            const groupTag = product.customFields?.find(field => field.key === 'custom-associated_collection')?.value;
            const groupInData = swatchData.find(group => group.groupId === groupTag);
            if(groupTag && !groupInData && !groupsToFetch.includes(groupTag)) {
                groupsToFetch.push(groupTag);
            } else if (isNewQuery && groupInData) {
                swatchDataToKeep.push(groupInData);
            }
        });

        if(groupsToFetch?.length < 1) return // no NEW groups: skip query

        fetchProductGroups(groupsToFetch)
            .then(async response => {
                const { data: { products: { products } } } = response;
                const swatchProducts = products.filter(product => product.availability === "InStock");
                if(swatchProducts?.length < 1) return;
                const updatedSwatchData = (isNewQuery) ? swatchDataToKeep : [...swatchData];

                groupsToFetch.forEach(group => {
                    const groupProds = swatchProducts.filter(product => product.attributes.find(attr => attr.key === 'custom-associated_collection')?.value === group);
                    groupProds.forEach(product => {
                        product.color = product.skus[0].attributes.find(attr => attr.key === 'Color')?.value;

                        // Look for swatch color metafield (fallback)
                        const variantWithColor = product.skus.find(sku =>
                            sku.attributes.find(attr =>
                                attr.key === 'custom-swatch_color' ||
                                attr.key === 'swatch_color' ||
                                attr.key === 'custom-swatchColor' ||
                                attr.key === 'custom-color'
                            )
                        );

                        // Extract swatch color/hex if available
                        if (variantWithColor) {
                            const colorAttr = variantWithColor.attributes.find(attr =>
                                attr.key === 'custom-swatch_color' ||
                                attr.key === 'swatch_color' ||
                                attr.key === 'custom-swatchColor' ||
                                attr.key === 'custom-color'
                            );
                            product.hex = colorAttr?.value || "#FFF";
                        } else {
                            product.hex = "#FFF";
                        }
                    })
                    updatedSwatchData.push({ groupId: group, products: groupProds });
                });

                // Resolve swatch images from Shopify Storefront API
                const allProducts = updatedSwatchData.flatMap(group => group.products);

                if (allProducts.length > 0) {
                    const productIdToSwatchUrl = await resolveSwatchImagesFromProducts(allProducts);

                    // Update products with resolved URLs
                    updatedSwatchData.forEach(group => {
                        group.products.forEach(product => {
                            if (productIdToSwatchUrl[product.productId]) {
                                product.swatchImage = productIdToSwatchUrl[product.productId];
                            }
                        });
                    });
                }

                setSwatchData(updatedSwatchData);
            })
            .catch(err => console.error(err))
    }, [ products, query?.query ]);

    return {
        swatchData,
    }
}
